import { Box, Skeleton, Stack, SxProps, Typography } from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";
import { PropsWithChildren } from "react";

type Props = {
    title?: string;
    titleVariant?: Variant;
    isLoading?: boolean;
    sx?: SxProps;
};

export default function GaiaPageComponent({
    title = undefined,
    titleVariant = "h1",
    isLoading = false,
    children,
    sx,
}: PropsWithChildren<Props>) {
    return (
        <Box sx={sx}>
            {title && <Typography variant={titleVariant}>{title}</Typography>}
            {isLoading && (
                <Stack gap={2}>
                    <Skeleton variant="rectangular" height={64} />
                    <Skeleton variant="rectangular" height={128} />
                </Stack>
            )}
            {!isLoading && children}
        </Box>
    );
}
